module.exports = __webpack_public_path__ + "static/media/DndWhite.3ad2fee3.svg";